type RouteTitleRule = {
  match: (pathname: string) => boolean;
  title: string;
};

const ROUTE_TITLE_RULES: RouteTitleRule[] = [
  { match: (p) => p.startsWith("/developer-console/applications/new"), title: "Developer Console · New Application" },
  { match: (p) => /^\/developer-console\/applications\/[^/]+\/edit/.test(p), title: "Developer Console · Edit Application" },
  { match: (p) => /^\/developer-console\/applications\/[^/]+$/.test(p), title: "Developer Console · Application Details" },
  { match: (p) => p.startsWith("/developer-console/applications"), title: "Developer Console · Applications" },
  { match: (p) => p.startsWith("/developer-console/docs"), title: "Developer Console · Documentation" },
  { match: (p) => p.startsWith("/developer-console"), title: "Developer Console" },
  { match: (p) => p.startsWith("/inspection-orders/approver/"), title: "Approver Inspection View" },
  { match: (p) => p.startsWith("/inspection-orders/inspector/"), title: "Inspector Inspection View" },
  { match: (p) => p.startsWith("/inspection-orders/create"), title: "Create Inspection Order" },
  { match: (p) => p.startsWith("/inspection-orders"), title: "Inspection Orders" },
  { match: (p) => p.startsWith("/workorders/createworkorder"), title: "Create Work Order" },
  { match: (p) => /^\/workorders\/edit\//.test(p), title: "Edit Work Order" },
  { match: (p) => /^\/workorders\/view\//.test(p), title: "Work Orders > View Order" },
  { match: (p) => p.startsWith("/workorders"), title: "Work Orders" },
  { match: (p) => /^\/assets\/edit\//.test(p), title: "Edit Asset" },
  { match: (p) => /^\/assets\/view\//.test(p), title: "Asset Details" },
  { match: (p) => p.startsWith("/assets"), title: "Assets" },
  { match: (p) => /^\/obligations\/[^/]+/.test(p), title: "Obligations" },
  { match: (p) => p.startsWith("/obligations"), title: "Obligations" },
  { match: (p) => p.startsWith("/task-list"), title: "Task List" },
  { match: (p) => p.startsWith("/document-library"), title: "Document Library" },
  { match: (p) => p.startsWith("/asset-onboarding"), title: "Asset Onboarding" },
  { match: (p) => p.startsWith("/select-company"), title: "Select company" },
  { match: (p) => p.startsWith("/dashboard"), title: "Dashboard" },
  { match: (p) => p.startsWith("/insights"), title: "Insights" },
  { match: (p) => p.startsWith("/manufacturer"), title: "Manufacturer" },
  { match: (p) => p.startsWith("/vendor"), title: "Vendor" },
  { match: (p) => p.startsWith("/masterdatarequest"), title: "Master Data Request" },
  { match: (p) => p.startsWith("/workorderstage"), title: "Work Order Stages" },
  { match: (p) => p.startsWith("/support"), title: "Support" },
  { match: (p) => p.startsWith("/team"), title: "Team" },
  { match: (p) => p.startsWith("/locationmap"), title: "Location Map" },
  { match: (p) => p.startsWith("/settings"), title: "Settings" },
  { match: (p) => p.startsWith("/ai-marketplace"), title: "AI Marketplace" },
  { match: (p) => p.startsWith("/plans"), title: "Plans" },
  { match: (p) => p.startsWith("/billing"), title: "Billing" },
  { match: (p) => p.startsWith("/subscription"), title: "Plan & Billing" },
  { match: (p) => p.startsWith("/onboardingsessions"), title: "Onboarding Sessions" },
  { match: (p) => p.startsWith("/onboarding"), title: "Onboarding" },
  { match: (p) => p.startsWith("/company-knowledge"), title: "Company Knowledge" },
  { match: (p) => p.startsWith("/company-notes"), title: "Company Notes" },
  { match: (p) => p.startsWith("/compliance-settings"), title: "Compliance Settings" },
];

export function getRoutePageTitle(pathname: string): string | null {
  const rule = ROUTE_TITLE_RULES.find((r) => r.match(pathname));
  return rule?.title ?? null;
}
